<app-dashboard-container
	class="dashboard-prestatieanalyse"
	[factTable]="factTable"
	[exportTypes]="exportTypes"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, $event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/prestatieanalyse_vso"
		[permanentFilterExpressions]="permanentFilterExpressions"
		[leerlingselectie]="false"
	></app-filter-panel>
	<app-filter-bar></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-legenda
				class="cl-header-utility"
				[attribute]="[variant() === DashboardVariant.ACTUEEL ? 'x_percentiel_neg_gem_pos' : 'x_prestatieanalyse_historie']"
				[keyIsClassName]="true"
			></app-legenda>
		</app-dashboard-header>
		<app-card-list
			[config]="this"
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilterExpressions"
			[groups]="groups"
			[subgroups]="variant() === DashboardVariant.ACTUEEL ? actueelSubgroups : historieSubgroups"
			[template]="cardTemplate"
			[variant]="variant()"
			class="prestatieanalyse"
			[class.historie]="variant() === DashboardVariant.HISTORIE"
			data-exportable
		>
			<ng-template #cardTemplate let-row="row" let-context="context" let-group="group" let-variant="variant">
				<div class="card-title">
					<h2>{{ group["pv_fk_vs.vs_nm_vestiging"] }}</h2>
				</div>
				<div class="card-content">
					@for (rec of getRecords(row, context, variant); track trackByPathKey($index, rec)) {
						<div class="card-cell" (click)="onClick(rec, context)">
							@switch (variant) {
								@case (DashboardVariant.ACTUEEL) {
									<app-card-pa-cell [data]="makeActueelCell(rec, context)"></app-card-pa-cell>
								}
								@case (DashboardVariant.HISTORIE) {
									<app-card-pa-history-cell [data]="makeHistorieCell(rec)(context)"></app-card-pa-history-cell>
								}
							}
						</div>
					}
				</div>
			</ng-template>
		</app-card-list>
	</section>
</app-dashboard-container>
